import { PaymentMethod } from "../../../../common/enums";
export const PAYMENT_INSTRUCTIONS_LABEL: Record<PaymentMethod, string> = {
  [PaymentMethod.ACH]: "ACH direct deposit",
  [PaymentMethod.EFT]: "EFT Canada bank transfer",
  [PaymentMethod.SEPA]: "SEPA Europe bank transfer",
  [PaymentMethod.Wire]: "wire transfer",
  [PaymentMethod.Check]: "check",
  [PaymentMethod.BACS]: "UK bank transfer",
  [PaymentMethod.BECS]: "Australia direct entry",
  [PaymentMethod.Other]: "Other",
};
